import { Box, Typography, Divider } from "@mui/material";

export default function SettingsGroup({
  title,
  description,
  children,
  showDivider,
}) {
  return (
    <Box>
      <Typography
        sx={{
          fontFamily: "Roboto, sans-serif",
          fontSize: 14,
          fontWeight: 500,
          color: "#212121",
          mb: 0.5,
        }}
      >
        {title}
      </Typography>

      {description && (
        <Typography
          sx={{
            fontFamily: "Roboto, sans-serif",
            fontSize: 12,
            color: "#4A5565",
            mb: 2,
          }}
        >
          {description}
        </Typography>
      )}

      {/* R4: Max 7±2 items per group (Miller's Law) */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2, // 16px between settings items
        }}
      >
        {children}
      </Box>

      {showDivider && <Divider sx={{ mt: 3, borderColor: "#E5E7EB" }} />}
    </Box>
  );
}
